<div class="input-group" (click)="openPicker()">
    <input
        #timeInput
        class="form-control pe-0"
        type="time"
        [value]="value()"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [required]="required()"
        [step]="step()"
        [attr.min]="minTime() || undefined"
        [attr.max]="maxTime() || undefined"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-invalid]="isInvalid()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        (input)="onInput($event)"
        (blur)="touched.set(true)"
    />
    <span class="input-group-text"><fa-icon [icon]="faClock"></fa-icon></span>
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
